import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { parse } from 'date-fns';

import { schedulePropTypes } from 'constants/propTypes';
import Confirm from 'components/Confirm';
import Message from 'components/Message';

import ProjectedSpotsConfirmation from '../ProjectedSpotsConfirmation';
import './PremiumOnlyModal.scss';

const messages = defineMessages({
  cancel: {
    id: 'yield-management.enable-schedule.premium-only-modal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'yield-management.enable-schedule.premium-only-modal.confirm',
    defaultMessage: 'Confirm',
  },
  scheduleInfo: {
    id: 'yield-management.enable-schedule.premium-only-modal.schedule-info',
    defaultMessage: 'Update {name} on {dateTime, date, long-w-dow-time-no-year} to 0 network spots?',
  },
});

const PremiumOnlyModal = ({ schedule }) => {
  const { scheduleName, startDate, startTime, spots } = schedule;
  const { smartspotRecommendedSpots } = spots || {};
  const date = parse(`${startDate} ${startTime}`, 'yyyy-MM-dd HH:mm', new Date());

  return (
    <Confirm cancelNode={<Message message={messages.cancel} />} acceptNode={<Message message={messages.confirm} />}>
      {({ buttons }) => (
        <div className="premium-only-modal">
          <div className="premium-only-modal__content">
            <p>
              <Message
                message={messages.scheduleInfo}
                values={{
                  name: <strong>{scheduleName}</strong>,
                  dateTime: date,
                }}
              />
            </p>
            {/* treat both null (no recommendation) and recommendation of 0 as no recommendation */}
            {!!smartspotRecommendedSpots && <ProjectedSpotsConfirmation networkCap={0} schedule={schedule} />}
          </div>
          {buttons}
        </div>
      )}
    </Confirm>
  );
};

PremiumOnlyModal.propTypes = {
  schedule: PropTypes.shape(schedulePropTypes),
};

export default PremiumOnlyModal;
